import React from 'react';

const TermsConditionsPT: React.FC = () => {
  return (
    <div className="prose max-w-none">
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Aceitação dos Termos</h2>
        <p className="mb-4">
          Ao baixar, instalar ou usar o aplicativo móvel e site do GatherPlay (o "Serviço"), você concorda em estar 
          vinculado a estes Termos e Condições ("Termos"). Se você não concordar com estes Termos, não use o Serviço.
        </p>
        <div className="bg-gray-100 p-4 rounded-lg mb-4">
          <p><strong>Provedor do Serviço:</strong></p>
          <ul className="list-none mt-2 space-y-1">
            <li>Empresa: BIXMO SRL</li>
            <li>Endereço: Chisinau, Moldávia</li>
            <li>Email: gatherplay.application@gmail.com</li>
          </ul>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Descrição do Serviço</h2>
        <p className="mb-4">
          GatherPlay é um jogo multijogador onde os jogadores interpretam cenários baseados em níveis de intensidade 
          numerados enquanto um jogador tenta adivinhar quem tem qual número. O Serviço inclui:
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Aplicativo móvel para dispositivos iOS e Android</li>
          <li>Aplicativo web acessível através de navegadores</li>
          <li>Funcionalidade de jogo multijogador</li>
          <li>Conteúdo de cartas de cenários</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Requisitos de Idade</h2>
        <p>
          GatherPlay é destinado a usuários com 6 anos ou mais. Usuários menores de 13 anos devem usar o Serviço sob 
          supervisão dos pais. Ao usar o Serviço, você declara que atende aos requisitos de idade.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Conduta do Usuário</h2>
        <p className="mb-4">Você concorda em usar o Serviço responsavelmente e concorda em NÃO:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Usar o Serviço para qualquer propósito ilegal ou em violação de qualquer lei local, estadual, nacional ou internacional</li>
          <li>Assediar, abusar ou prejudicar outros jogadores</li>
          <li>Tentar fazer engenharia reversa, modificar ou hackear o aplicativo</li>
          <li>Usar scripts automatizados ou bots para interagir com o Serviço</li>
          <li>Compartilhar conteúdo inadequado durante o jogo</li>
          <li>Interferir ou interromper o Serviço ou servidores</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Direitos de Propriedade Intelectual</h2>
        
        <h3 className="text-xl font-semibold text-gray-700 mb-3">5.1 Nosso Conteúdo</h3>
        <p className="mb-4">Todo o conteúdo no GatherPlay, incluindo mas não limitado a:</p>
        <ul className="list-disc pl-6 mb-4 space-y-1">
          <li>Mecânicas do jogo e regras</li>
          <li>Cartas de cenários e conteúdo do jogo</li>
          <li>Código de software e algoritmos</li>
          <li>Gráficos, logotipos e elementos de design</li>
          <li>Texto e materiais escritos</li>
        </ul>
        <p className="mb-4">é propriedade da BIXMO SRL e protegido por direitos autorais, marcas registradas e outras leis de propriedade intelectual.</p>

        <h3 className="text-xl font-semibold text-gray-700 mb-3">5.2 Sua Licença</h3>
        <p>
          Concedemos a você uma licença limitada, não exclusiva, não transferível para usar o Serviço para fins 
          pessoais, não comerciais de acordo com estes Termos.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Recursos Premium e Pagamentos</h2>
        
        <h3 className="text-xl font-semibold text-gray-700 mb-3">6.1 Compra no Aplicativo</h3>
        <p className="mb-4">
          GatherPlay oferece uma atualização premium disponível através de compra no aplicativo que remove 
          anúncios. Esta é uma compra única vinculada à sua conta da loja de aplicativos.
        </p>

        <h3 className="text-xl font-semibold text-gray-700 mb-3">6.2 Reembolsos</h3>
        <p className="mb-4">
          As políticas de reembolso são regidas pelas respectivas políticas da loja de aplicativos (Apple App Store 
          ou Google Play Store). Não processamos reembolsos diretamente.
        </p>

        <h3 className="text-xl font-semibold text-gray-700 mb-3">6.3 Mudanças de Preço</h3>
        <p>
          Reservamo-nos o direito de alterar o preço dos recursos premium a qualquer momento, embora as mudanças 
          não afetem compras existentes.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Publicidade</h2>
        <p>
          A versão gratuita do GatherPlay exibe anúncios. Ao usar a versão gratuita, você consente em visualizar 
          estes anúncios. Os anúncios são fornecidos por redes de terceiros e não somos responsáveis pelo seu conteúdo.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Dados e Privacidade</h2>
        <p>
          Sua privacidade é importante para nós. Revise nossa Política de Privacidade, que explica como coletamos, 
          usamos e protegemos suas informações. A Política de Privacidade está incorporada a estes Termos por referência.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Disponibilidade do Serviço</h2>
        
        <h3 className="text-xl font-semibold text-gray-700 mb-3">9.1 Disponibilidade</h3>
        <p className="mb-4">
          Nos esforçamos para manter o Serviço disponível 24/7, mas não garantimos acesso ininterrupto. O Serviço 
          pode estar temporariamente indisponível devido a:
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-1">
          <li>Manutenção programada</li>
          <li>Dificuldades técnicas</li>
          <li>Fatores além do nosso controle</li>
        </ul>

        <h3 className="text-xl font-semibold text-gray-700 mb-3">9.2 Atualizações</h3>
        <p>
          Podemos atualizar o Serviço de tempos em tempos para adicionar recursos, corrigir bugs ou melhorar o 
          desempenho. Algumas atualizações podem ser necessárias para o uso contínuo do Serviço.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Limitação de Responsabilidade</h2>
        <p className="mb-4">Na máxima extensão permitida pela lei aplicável:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>O Serviço é fornecido "como está" sem garantias de qualquer tipo</li>
          <li>Não somos responsáveis por quaisquer danos indiretos, incidentais, especiais ou consequenciais</li>
          <li>Nossa responsabilidade total não excederá o valor que você pagou pelos recursos premium (se houver)</li>
          <li>Não somos responsáveis por qualquer perda de dados ou interrupção do serviço</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Indenização</h2>
        <p>
          Você concorda em indenizar e isentar a BIXMO SRL de quaisquer reivindicações, danos ou despesas 
          decorrentes do seu uso do Serviço ou violação destes Termos.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">12. Rescisão</h2>
        
        <h3 className="text-xl font-semibold text-gray-700 mb-3">12.1 Rescisão por Você</h3>
        <p className="mb-4">Você pode parar de usar o Serviço a qualquer momento desinstalando o aplicativo.</p>

        <h3 className="text-xl font-semibold text-gray-700 mb-3">12.2 Rescisão por Nós</h3>
        <p className="mb-4">
          Podemos rescindir ou suspender seu acesso ao Serviço a qualquer momento, com ou sem motivo, com ou sem aviso.
        </p>

        <h3 className="text-xl font-semibold text-gray-700 mb-3">12.3 Efeito da Rescisão</h3>
        <p>
          Após a rescisão, seu direito de usar o Serviço cessa imediatamente. Disposições que devem sobreviver à 
          rescisão (incluindo direitos de propriedade intelectual, limitação de responsabilidade e indenização) continuarão a se aplicar.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">13. Lei Aplicável</h2>
        <p>
          Estes Termos são regidos e interpretados de acordo com as leis da República da Moldávia, sem consideração 
          às suas disposições de conflito de leis.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">14. Resolução de Disputas</h2>
        <p>
          Quaisquer disputas decorrentes destes Termos ou do uso do Serviço serão resolvidas através de arbitragem 
          vinculante de acordo com as leis da República da Moldávia, ou nos tribunais competentes de Chisinau, Moldávia.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">15. Alterações nos Termos</h2>
        <p className="mb-4">Reservamo-nos o direito de modificar estes Termos a qualquer momento. Notificaremos os usuários sobre mudanças materiais:</p>
        <ul className="list-disc pl-6 mb-4 space-y-1">
          <li>Publicando Termos atualizados no aplicativo</li>
          <li>Atualizando a data "Última Atualização"</li>
          <li>Fornecendo notificação no aplicativo para mudanças significativas</li>
        </ul>
        <p>O uso contínuo do Serviço após mudanças constitui aceitação dos Termos atualizados.</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">16. Divisibilidade</h2>
        <p>
          Se qualquer disposição destes Termos for considerada inexequível, o restante dos Termos permanecerá 
          em plena força e efeito.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">17. Informações de Contato</h2>
        <p className="mb-4">Para perguntas sobre estes Termos e Condições, entre em contato conosco:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Email: gatherplay.application@gmail.com</li>
          <li>Empresa: BIXMO SRL, Chisinau, Moldávia</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">18. Acordo Completo</h2>
        <p>
          Estes Termos, junto com nossa Política de Privacidade, constituem o acordo completo entre você e a 
          BIXMO SRL sobre o uso do Serviço.
        </p>
      </section>

      <div className="bg-blue-50 p-4 rounded-lg mt-8">
        <p className="text-sm text-blue-800">
          Ao usar o GatherPlay, você reconhece que leu, entendeu e concorda em estar vinculado a estes Termos e Condições.
        </p>
      </div>
    </div>
  );
};

export default TermsConditionsPT;